module.exports = __webpack_public_path__ + "static/media/barber.f89a7e19.png";